import * as Yup from "yup";

export const addAdminValidationSchema = Yup.object().shape({
    title: Yup.string().required("Title is required"),
    firstName: Yup.string().required('First Name  is required'),
    lastName: Yup.string().required('Last Name is required'),
    email: Yup.string().matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, "Invalid email format").required('Email is required'),
    password: Yup.string().required('Password is required'),
    address1: Yup.string().required('Address1 is required'),
    address2: Yup.string().required('Address2 is required'),
    address3: Yup.string().required('Address3 is required'),
    mobile: Yup.string().required('Mobile is required'),
    dateOfBirth: Yup.string().required('Date Of Birth is required'),
    postCode: Yup.string().required('PostCode is required'),
    nationality: Yup.string().required('Nationality is required'),
    occupation: Yup.string().required('Occupation is required'),
    country: Yup.string().required('Country is required'),
    county: Yup.string().required('County is required'),
  });